import {Routes, Route, Navigate, useLocation} from 'react-router-dom';
import Login from "../Auth/Login/Login";
import Invoices from "../Invoices/Invoices";
import InvoiceView from "../InvoiceView/InvoiceView";
import RouteError from "../RouteError/RouteError";
import Register from "../Auth/Register/Register";
import Account from "../Account/Account";
import Customer from "../Customer/Customer";
import Users from "../Users/Users";
import ChangePassword from "../ChangePassword/ChangePassword";

const isAuthenticated = () => {
    const token = sessionStorage.getItem("authTokenData");
    return !!token;
};

const ProtectedRoute = ({children}) => {
    return isAuthenticated() ? children : <Navigate to="/login" replace/>;
};

const AppRoutes = () => {
    const location = useLocation();

    return (
        <Routes location={location} key={location.key}>
            <Route path="/login" element={<Login/>}/>
            <Route path="/register" element={<Register/>}/>
            <Route
                path="/"
                element={
                    <ProtectedRoute>
                        <Invoices/>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/users"
                element={
                    <ProtectedRoute>
                        <Users/>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/account"
                element={
                    <ProtectedRoute>
                        <Account/>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/change-password"
                element={
                    <ProtectedRoute>
                        <ChangePassword/>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/customer"
                element={
                    <ProtectedRoute>
                        <Customer/>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/invoice/:id"
                element={
                    <ProtectedRoute>
                        <InvoiceView/>
                    </ProtectedRoute>
                }
            />
            <Route path="*" element={<RouteError/>}/>
        </Routes>
    );
};

export default AppRoutes;
